<template>
  <Container class="PageInvitationNew" v-if="invitationId">
    <Card class="main-card">
      <p class="heading">招待される方のスマートフォンで<br>QRコードを読み込んでください</p>
      <div class="qr-wrap">
        <QRCode :value="inviteUrl" :options="{width: 200}" />
      </div>
      <p class="url">{{inviteUrl}}</p>
    </Card>
    <a :href="lineUrl" target="_blank" class="line">
      <UiButton>招待コードをLINEで送る</UiButton>
    </a>
  </Container>
  <Loader v-else />
</template>

<script>
import Card from '@/components/atoms/Card'
import Container from '@/components/atoms/Container'
import Loader from '@/components/atoms/Loader'
import QRCode from '@chenfengyuan/vue-qrcode';
import UiButton from '@/components/atoms/UiButton'

import FirebaseInvitation from '@/firebase/invitations.ts'
const firebaseInvitation = new FirebaseInvitation()

export default {
  name: 'PageInvitationNew',
  layout: 'app',
  components: {
    Card,
    Container,
    Loader,
    QRCode,
    UiButton,
  },
  data() {
    return {
      invitationId: '',
    }
  },
  props: {
    child: {},
  },
  computed: {
    inviteUrl() {
      const location = window.location
      return `${location.protocol}//${location.host}/invitations/${this.invitationId}`
    },
    lineUrl() {
      return `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(this.inviteUrl)}`
    },
  },
  async mounted() {
    this.invitationId = await firebaseInvitation.createInvitation(this.child)
  },
}
</script>

<style scoped lang="scss">
.heading {
  text-align: center;
  font-weight: bold;
  margin-bottom: 5px;
}
.qr-wrap {
  text-align: center;
}
.url {
  text-align: center;
  font-size: 10px;
}
.main-card {
  padding: 30px 0;
  margin-bottom: 20px;
}
.line {
  text-decoration: none;
}
</style>
